import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const Breadcrumb = ({ items }) => {
  return (
    <nav className="bg-gray-50 py-3 border-b border-gray-200">
      <div className="container mx-auto px-4">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          <li>
            <Link 
              to="/" 
              className="flex items-center gap-1 text-gray-600 hover:text-[#00B4D8] transition-colors"
            >
              <Home className="w-4 h-4" />
              <span>Início</span>
            </Link>
          </li>
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <li>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </li>
              <li>
                {item.link ? (
                  <Link 
                    to={item.link}
                    className="text-gray-600 hover:text-[#00B4D8] transition-colors"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-gray-900 font-medium">{item.label}</span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </div>
    </nav>
  );
};
